module.exports = __webpack_public_path__ + "assets/media/lunch.e27c22d9.mp3";